module.exports = __webpack_public_path__ + "img/compact.11e29bb7.png";